<template>
  <div class="app" v-title data-title="广富林文化遗址公园">
    <component :is="headerComponent" />
    <div class="index-banner" v-if="topCarousel && topCarousel.Items">
      <el-carousel height="660px">
        <el-carousel-item v-for="item in topCarousel.Items" :key="item.Id">
          <!-- <img :src="item.Photo + '!/both/1905x665'" class="db wp100" alt="" /> -->
           <div class="index-banner-pic" :style="'background-image: url(\'' + item.Photo + '!/both/1905x665' + '\');'"></div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="index-banner" v-else>
      <img src="../assets/images/banner.png" class="db wp100" alt="banner">
    </div>
    <div class="index-open">
      <div class=" w1600 auto df align_center">
        <div class="index-opentime rel pt10 mra">
          <h3 class="f18 fw b mt20">参观指南</h3>
          <div class="index-open-text fy f16 lh18 mt10" v-if="visitGuide && visitGuide.ContentText" v-html="visitGuide.ContentText"></div>
          <!-- <div class="abs index-open-icon">
            <img src="../assets/images/open-icon.png" class="db" alt="">
          </div> -->
        </div>
        <div class="df align_center mt20">
          <!-- <div class="df align_center mr40" v-if="yyxz && yyxz.ThirdLink && yyxz.ThirdLink.Path"> -->
            <div v-if="yyxz && yyxz.ThirdLink && yyxz.ThirdLink.Path" @click="typeJump(yyxz)" class="df align_center mr40 show-hand">
              <div class="f18 b fw">{{ yyxz.Name }}</div>
              <img src="../assets/images/arrow-y2.png" class="db w20" alt="">
            </div>
          <!-- </div> -->
          <!-- <div class="df align_center mr40" v-if="jtzn && jtzn.ThirdLink && jtzn.ThirdLink.Path"> -->
            <router-link v-if="jtzn && jtzn.ThirdLink && jtzn.ThirdLink.Path" :to="jtzn.ThirdLink.Path" class="df align_center mr40">
              <div class="f18 b fw">{{ jtzn.Name }}</div>
              <img src="../assets/images/arrow-y2.png" class="db w20" alt="">
            </router-link>
          <!-- </div> -->
        </div>
        <div class="df align_center mt20" v-if="cgyy">
          <img v-if="cgyy.Photo" :src="cgyy.Photo" width="80" height="80" class="db w80" alt="">
          <div class="ml20">
            <div class="f18 b fw">{{ cgyy.Name }}</div>
            <div class="fy mt5" v-if="cgyy.ContentText">{{ cgyy.ContentText | clearHtml }}</div>
            <router-link v-if="cgyy && cgyy.ThirdLink && cgyy.ThirdLink.Path" :to="cgyy.ThirdLink.Path" class="df align_center">
              <div class="fy" v-if="cgyy.Remark">{{ cgyy.Remark }}</div>
              <img src="../assets/images/arrow-y.png" class="db w20" alt="">
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="index-gonggao bgy df align_center w1600 auto box-border">
      <div class="f18 fw b index-gonggao-tit">通知公告</div>
      <div class="scroll-container">
        <div class="fo scroll-text" v-if="notice && notice.ContentText" v-html="notice.ContentText"></div>
      </div>
    </div>
    <div class="index-box1">
      <div class="index-box1-bg mt20">
        <div class="index-box1-line ">
          <img src="@/assets/images/index-box1-line.png" class="db wp100" alt="">
        </div>
        <div class="index-tit df align_center flex_column justify_center ">
          <div class="f30 b">印象富林</div>
          <div class="f12">Impressions of Guangfulin</div>
        </div>
      </div>
      <div class="f16 w1000 auto mt30 lh20 tc" v-if="yxfl && yxfl.ContentText" v-html="yxfl.ContentText"></div>
      <div class="index-more fa_wh df align_center justify_center auto mt30 rel">
        <router-link v-if="yxflLink && yxflLink.ThirdLink && yxflLink.ThirdLink.Path" :to="yxflLink.ThirdLink.Path" class="f15 fw">查看更多</router-link>
      </div>
    </div>
    <div class="index-box2-bg mt-60 mb40">
      <div class="index-tit df align_center flex_column justify_center pt150">
        <div class="f30 b mt20">富林景点</div>
        <div class="f12">Scenic spots</div>
      </div>
      <div class="rel mt40 " v-if="position && position.length > 0">
        <div class="index-map rel">
          <img src="../assets/images/index-map.png" class="db" alt="" />
          <div class="index-map-item">
            <div class="map-name"  @click="mapClick(item)" :class="item.id == mapSelect.id ? 'active' : ''"
              v-for="item in position" :key="item.Id" :style="{ top: item.top, left: item.left }">
              <div class="map-name-text">
                {{ item.name }}
              </div>
            </div>
            <!-- <div class="map-name active" style="top: 150px; left: 970px;">
              <div class="map-name-text">
                上海之根文化展示馆
              </div>
            </div>
            <div class="map-name" style="top: 150px; left: 780px;">
              <div class="map-name-text">
                木雕展示馆
              </div>
            </div>
            <div class="map-name" style="top: 280px; left: 726px;">
              <div class="map-name-text">
                富林塔
              </div>
            </div>
            <div class="map-name" style="top: 330px; left: 920px;">
              <div class="map-name-text">
                陈子龙纪念馆
              </div>
            </div>
            <div class="map-name" style="top: 376px; left: 1013px;">
              <div class="map-name-text">
                富林印记
              </div>
            </div>
            <div class="map-name" style="top: 325px; left: 650px;">
              <div class="map-name-text">
                知也禅寺
              </div>
            </div>
            <div class="map-name" style="top: 338px; left: 800px;">
              <div class="map-name-text">
                三元宫
              </div>
            </div> -->
          </div>
        </div>
        <div class="index-box2-intro abs" v-if="mapSelect && showMapRight">
          <div class="f24 b tc rel" v-if="mapSelect.name">
            <div>{{ mapSelect.name }}</div>
            <div class="abs index-box2-close" @click="closeMapRight">
              <img src="../assets/images/close.png" width="22" height="22" class="db" alt="">
            </div>
          </div>
          <div class="f16 mt10 tc line_clamp1" v-if="mapSelect.subTitle">{{ mapSelect.subTitle }}</div>
          <img :src="mapSelect.photo + '!/both/678x378'" class="db mt50 index-box2-pic" alt="" />
        </div>
        <!-- <div class="index-box2-intro abs">
          <div class="f24 b tc">上海之根文化展示馆</div>
          <div class="f16 mt10 tc line_clamp1">景点一句话介绍景点一句话介绍景点一句话介绍景点一句话介绍</div>
          <img src="../assets/images/index-p1.png" class="db mt50 index-box2-pic" alt="" />
        </div> -->
      </div>
    </div>
    <component :is="bottomComponent" />
  </div>
</template>

<script>
import Header from '../components/header.vue'
import Bottom from '../components/bottom.vue'
import promotionService from '@/services/client/cont/promotion'
import mapPositionService from '@/services/client/cont/map'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',
      code: 'app-index',
      topCarouselCode: 'app-index-topcarousel',
      topCarousel: null,
      notice: null,
      yxfl: null,
      yxflLink: null,
      visitGuide: null,
      background: null,
      yyxz: null,
      jtzn: null,
      cgyy: null,
      mapPositionFilter: {
        GroupId: 5,
        Page: 1,
        PageSize: 50,
      },
      position: null,
      mapSelect: null,
      showMapRight: true,
    }
  },
  components: { Header, Bottom},
  mounted(){
    this.loadData();
    this.loadMapPosition();
    this.loadTopCarouselData();
  },
  methods:{
    closeMapRight() {
      this.showMapRight = false;
    },
    loadData() {
      promotionService.detail(this.code).then(res => {
        if(res.Code == 200 && res.Data && res.Data.Items && res.Data.Items.length > 0) {
          let data = res.Data;
          this.notice = data.Items[0];
          this.yxfl = data.Items[1];
          this.yxflLink = data.Items[2];
          this.visitGuide = data.Items[3];
          this.background = data.Items[4];
          this.yyxz = data.Items[5];
          this.jtzn = data.Items[6];
          this.cgyy = data.Items[7];
        }
      })
    },
    loadMapPosition() {
      mapPositionService.position.list(this.mapPositionFilter).then(res => {
        if(res.Code == 200 && res.Data && res.Data.List && res.Data.List.length > 0) {
          this.position = res.Data.List.map(item => {
            let top = '';
            let left = '';
            if(item.CustomCode) {
              const split = item.CustomCode.split(',');
              top = split[0] + 'px';
              left = split[1] + 'px';
            }
            return {
              id: item.Id,
              top: top,
              left: left,
              photo: item.Photo,
              name: item.Name,
              subTitle: item.SubTitle
            };
          });
          this.mapSelect = this.position[0];
        }
      })
    },
    loadTopCarouselData() {
      this.topCarousel = null;
      promotionService.detail(this.topCarouselCode).then(res => {
        if(res.Code == 200 && res.Data && res.Data.Items && res.Data.Items.length > 0) {
          this.topCarousel = res.Data;
        }
      })
    },
    mapClick(item) {
      this.mapSelect = item;
      this.showMapRight = true;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/index.vue